import React from 'react';

import { css, cx } from '@emotion/css';

import { FontSizes } from '@/assets/fonts.ts';
import { Icons } from '@/assets/icons.ts';
import { BaseTooltip } from '@/components/floating/BaseTooltip.tsx';
import { useStyles } from '@/hooks/useStyles.ts';
import { Message } from '@/models/MessagingModel.ts';
import { Button } from '@/uiKit/atoms/Button.tsx';

export type MessageAttachmentsProps = {
  message: Message;
  className?: string;
};

export const MessageAttachments: React.FC<MessageAttachmentsProps> = ({
  message,
  className,
}) => {
  const styles = useStyles(makeStyles);

  if (!message.attachments) {
    return null;
  }

  return message.attachments.map((attachment, i) => (
    <BaseTooltip
      type="hover"
      placement="top"
      content={attachment.name}
      role="tooltip"
      key={i}
    >
      <Button
        variant="text"
        startIcon={<Icons.download className={styles.icon} />}
        onClick={() => window.open(attachment.url, '_blank')}
        className={cx(styles.container, className)}
      >
        {attachment.name}
      </Button>
    </BaseTooltip>
  ));
};

const makeStyles = () => ({
  container: css({
    maxWidth: '100%',
    padding: 0,
  }),
  icon: css({
    borderBottom: 'rgba(0, 0, 0, 0.5)',
    width: FontSizes.bodySmall,
    height: FontSizes.bodySmall,
  }),
});
